import React, { Component } from 'react'

import { StyledEyebrow } from './Typestack.styles'

export default class Eyebrow extends Component {
  static propTypes = {}

  render() {
    const {
      children,
      componentProp,
      ...rest
    } = this.props

    const Component = StyledEyebrow(componentProp)

    return (
      <Component {...rest}>
        {children}
      </Component>
    )
  }
}
